import useTheme from "hooks/useTheme";
import ArrowBackIcon from "theme/icons/ArrowBack";

const DaffiPay = ({ navigatePage }) => {
	const { appLanguage, themeColor } = useTheme();

	return (
		<div className="relative flex flex-col w-full items-center justify-start col-span-2 py-2 px-3 space-y-4">
			<div className="absolute top-0 left-20">
				<ArrowBackIcon className={`w-4 cursor-pointer`} fill={themeColor?.hex} onClick={() => navigatePage(-1)} />
			</div>
			<div className="flex w-full items-center justify-center">
				<p className={`text-md font-bold ${themeColor?.text}`}>{appLanguage?.comingSoon}</p>
			</div>
			<div className="flex">
				<p className={`text-2xl font-bold ${themeColor?.text}`}>Daffi</p>
				<p className={`text-2xl font-bold italic ${themeColor?.text}`}>Pay</p>
			</div>

			<div className="flex flex-col w-full">
				<div className="flex flex-col w-full items-center justify-center">
					<p
						className={`text-sm text-center ${themeColor?.text}`}
						dangerouslySetInnerHTML={{ __html: appLanguage?.useYourDaffiWallet }}
					/>
				</div>
				<div className="flex flex-col w-full items-center justify-center">
					<p
						className={`text-sm text-center ${themeColor?.text}`}
						dangerouslySetInnerHTML={{ __html: appLanguage?.toPayOnline }}
					/>
				</div>
			</div>
		</div>
	);
};

export default DaffiPay;
